const firebase_config = {
    apiKey: "AIzaSyCRAQvzOE18svjtNOSl78D71gYl6Th3Cx0",
    authDomain: "admin-27540.firebaseapp.com",
    projectId: "admin-27540",
    storageBucket: "admin-27540.appspot.com",
    messagingSenderId: "1034308070393",
    appId: "1:1034308070393:web:4600c046e31c309510eb28",
    measurementId: "G-T61X4SYMDT"
};

export default firebase_config;
